module.exports = (__webpack_require__(32))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/layout/HeaderUserView.js from dll-reference girder_plugin_jobs
// module id = 74
// module chunks = 0